import React, { useMemo } from "react";
import { dateValue, mapNameOptions, SectionTitle } from "../EmployeeForm";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../ui/table";
import { Calendar } from "primereact/calendar";
import { toIST } from "../../../utils/calculateMargin";
import { Dropdown } from "primereact/dropdown";
import { Button } from "../../../ui/buttons";
import { Plus, Trash2 } from "lucide-react";
import { useSelector } from "react-redux";

function Designation({
  designationHistory,
  setDesignationHistory,
  updateArray,
  removeArrayItem,
}) {
  const { designations } = useSelector((state) => state.masterData);
  const designationOptions = useMemo(
    () => mapNameOptions(designations),
    [designations],
  );
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Designation Details</SectionTitle>

      <div className="w-full overflow-x-auto border rounded-md mt-2">
        <Table className="min-w-[1000px]">
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead>From *</TableHead>
              <TableHead>To</TableHead>
              <TableHead>Designation *</TableHead>
              <TableHead className="text-right">Action</TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {designationHistory.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Calendar
                    value={dateValue(item.fromDate)}
                    onChange={(e) =>
                      updateArray(
                        setDesignationHistory,
                        index,
                        "fromDate",
                        toIST(e.value),
                      )
                    }
                    showIcon
                    dateFormat="dd/mm/yy"
                    placeholder="From"
                    className="w-full bg-input border border-gray-300 rounded-md"
                    inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell>
                  <Calendar
                    value={dateValue(item.toDate)}
                    onChange={(e) =>
                      updateArray(
                        setDesignationHistory,
                        index,
                        "toDate",
                        toIST(e.value),
                      )
                    }
                    showIcon
                    dateFormat="dd/mm/yy"
                    placeholder="To / Current"
                    className="w-full bg-input border border-gray-300 rounded-md"
                    inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell>
                  <Dropdown
                    value={item.designation}
                    options={designationOptions}
                    onChange={(e) =>
                      updateArray(
                        setDesignationHistory,
                        index,
                        "designation",
                        e.value,
                      )
                    }
                    placeholder="Select Designation"
                    filter
                    className="w-full px-1 text-sm border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
                  />
                </TableCell>

                <TableCell className="text-right">
                  <Button
                    type="button"
                    variant="ghost"
                    disabled={designationHistory.length === 1}
                    onClick={() =>
                      removeArrayItem(setDesignationHistory, index)
                    }
                  >
                    <Trash2 className="h-4 w-4 text-red-500" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          setDesignationHistory((prev) => [
            ...prev,
            { fromDate: null, toDate: null, designation: "" },
          ])
        }
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add Designation
      </Button>
    </section>
  );
}

export default Designation;
